import React from 'react'
import _ from 'lodash'
import { Query } from 'react-apollo'
import { message, Select } from 'antd'
import {
  SmallText, Div, Button as KonsysButton, Loading, H3,
} from 'konsys-ui'
import history from '../../history'
import { theme } from '../../styles/_variables'
import { status, statusText } from '../../pages/user-page/constants'
import { P } from '../../pages/user-page/styled'
import { GET_ROLES } from '../../constants/graphql/query'
import PERMISSION from '../../constants/permissions'

const { color } = theme

export const CellText = props => (
  <P font='sarabun' padding='3px' {...props}>{props.children}</P>
)

export const HeaderLabel = props => (
  <SmallText bold color={color.coolGrey} font='sarabun' style={{ fontWeight: 700 }}>{props.children}</SmallText>
)

export const InputWithPlaceHolder = ({ handleChange }) => (
  <input placeholder='ค้นหา' onChange={e => handleChange(e.target.value)}/>
)

export const StatusSelector = ({
  handleChange, filter, disabled,
}) => {
  const arr = [
    { value: status.ACTIVE, text: statusText.ACTIVE },
    { value: status.INACTIVE, text: statusText.INACTIVE },
  ]

  const filterer = filter ? _.concat({ value: 'ALL', text: 'ทั้งหมด' }, arr) : arr

  return (
    <Select
      disabled={disabled}
      dropdown
      style={{ width: 130 }}
      defaultValue="ทั้งหมด"
      onChange={e => handleChange(e)}
    >
      {
        filterer.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
      }
    </Select>
  )
}

export const RolesSelector = ({
  handleChange, disabled,
}) => (
    <Query
      query={GET_ROLES}
    >{({ data, loading, error }) => {
      if (loading) return <Loading size='small'/>
      if (error) return <H3>เกิดข้อผิดพลาด</H3>

      const mapped = _.concat({ id: undefined, description: 'ทั้งหมด' }, data.RoleList.lists.map(v => ({ id: v.id, value: v.name, description: v.description })))
      return (
        <Select
          disabled={disabled}
          dropdown
          style={{ width: 130 }}
          defaultValue="ทั้งหมด"
          onChange={e => handleChange(e)}
        >
          {
            mapped.map(v => <Select.Option key={v.value} value={v.id}>{v.description}</Select.Option>)
          }
        </Select>
      )
    }}
    </Query>
)

export const ActionSelector = ({ disabled, props }) => (
  <Select
    disabled={disabled}
    dropdown
    data={[
      { value: 'view', text: 'ดูรายละเอียด' },
      { value: 'edit', text: 'แก้ไข' },
    ]}
    buttonProps={{
      text: 'ดูรายละเอียด',
      ghost: true,
      color: color.primaryColor,
      small: true,
      width: '120px',
    }}
    onChange={(e) => {
      if (e.value === 'edit') {
        history.push(`/client/edit/${props.original.id}`)
      } else {
        history.push(`/client/view/${props.original.id}`)
      }
    }}
  />
)

export const Wrapper = props => (
  <Div
    display='block'
    width='100%'
    flexDirection='row'
    padding={props.padding || '40px 0'}
    justifyContent={props.center && 'center'}
    alignItems='flex-end'
    style={{ borderBottom: `1px solid ${color.paleGrey}`, overflow: props.overflow && 'auto' }}
  >
    {props.children}
  </Div>
)

export const ActionBar = ({
  loading, isViewMode, doAction, mutationVariables, props,
}) => (
  <Div
    position='fixed'
    height='72px'
    bottom='0'
    left='0'
    right='0'
    style={{ background: `${color.primaryColor}33` }}
    display='flex'
    justifyContent='flex-end'
    alignItems='center'
    padding='0 32px 0 0'
  >
    <KonsysButton
      loading={loading}
      disabled={loading || (isViewMode && !_.includes(window.perms, PERMISSION.UPDATE_USER))}
      text={isViewMode ? 'แก้ไข' : 'บันทึก'}
      icon={isViewMode ? 'fas fa-edit' : 'fas fa-save'}
      inverse
      onClick={() => {
        if (isViewMode) history.push(`/user/edit/${props.match.params.id}`)
        else {
          doAction({
            variables: {
              id: parseInt(props.match.params.id, 10),
              ...mutationVariables,
              customerId: (mutationVariables?.customerId.map(customer => customer.customerId)).filter(id => _.isInteger(id)),
            },
          }).then(({ data }) => {
            const resp = data.UpdateUser

            if (resp.success) {
              message.success(resp.message)
              history.push('/user')
            } else message.error(resp.message)
          })
        }
      }}
    />
  </Div>
)
